import { AUTH_CONFIG } from "../pages/Authentication/auth.config";

export const setLastActivityTime = () => {
  const time = Date.now().toString();
  localStorage.setItem("lastActivityTime", time);
  // console.log(
  //   "Activity time updated:",
  //   new Date(parseInt(time)).toLocaleString()
  // );
};

export const getLastActivityTime = () => {
  const time = parseInt(localStorage.getItem("lastActivityTime")) || null;
  console.log(
    "Last activity time:",
    time ? new Date(time).toLocaleString() : "null"
  );
  return time;
};

export const clearLastActivityTime = () => {
  localStorage.removeItem("lastActivityTime");
  console.log("Activity time cleared");
};

export const isSessionExpired = () => {
  const lastActivity = getLastActivityTime();
  if (!lastActivity) return true;

  const timeDiff = Date.now() - lastActivity;
  const isExpired = timeDiff >= AUTH_CONFIG.SESSION.DURATION;
  console.log("Session expired check:", {
    timeDiff: Math.round(timeDiff / 1000) + " seconds",
    autoLogoutTime:
      Math.round(AUTH_CONFIG.SESSION.DURATION / 1000) + " seconds",
    isExpired,
  });
  return isExpired;
};

export const shouldShowWarning = () => {
  const lastActivity = getLastActivityTime();
  if (!lastActivity) return false;

  const timeSinceLastActivity = Date.now() - lastActivity;
  const shouldWarn =
    timeSinceLastActivity >=
    AUTH_CONFIG.SESSION.DURATION - AUTH_CONFIG.SESSION.WARNING_OFFSET;
  console.log("Warning check:", {
    timeSinceLastActivity:
      Math.round(timeSinceLastActivity / 1000) + " seconds",
    warningThreshold:
      Math.round(
        (AUTH_CONFIG.SESSION.DURATION - AUTH_CONFIG.SESSION.WARNING_OFFSET) /
          1000
      ) + " seconds",
    shouldWarn,
  });
  return shouldWarn;
};
